/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-08 15:28:01
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-29 11:00:27
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/SimpleProduct/tools/convertDataFromServer.ts
 */
import { ProductItem } from 'src/types/common/product';
import { randomNumber, reduxUpdatedStatusControl } from 'src/tools/helper';
import { buildGroupedPriceSettings } from 'src/tools/helper';
export const convertDatafromServer = (data: ProductItem, priceTiers) => {
  //
  const {
    sku,
    name,
    measurementUnit,
    remarks,
    codes,
    description,
    brand,
    barcode,
    //salesChannelQuotas = [],
    // warehouseStocks,
    dangerousGoodsClasses,
  } = data;
  //const _;
  // const salesChannelAvailableQuantity = salesChannelQuotas.map((i) => {
  //   const { name, salesChannelUuid, channelType, availableQuantity } = i;
  //   return {
  //     name,
  //     type: channelType,
  //     quantity: availableQuantity || 0,
  //     uuid: salesChannelUuid,
  //   };
  // });
  // const salesChannelAvailablePresaleQuantity = salesChannelQuotas.map((i) => {
  //   const { name, salesChannelUuid, channelType, presaleQuantity } = i;
  //   return {
  //     name,
  //     type: channelType,
  //     quantity: presaleQuantity || 0,
  //     uuid: salesChannelUuid,
  //   };
  // });
  const subCollapseOpen = {
    // salesChannelAvailableQuantity: true,
    // salesChannelAvailablePresaleQuantity: true,
  };
  const productInfo = {
    sku,
    name,
    measurementUnit,
    remarks,
    codes,
    description,
    brand,
    barcode,
    dangerousGoodsClasses,
  };
  const {
    storeUuid,
    status,
    uuid,
    productStorage,
    productType,
    thumbnailImage,
    defaultCurrency,
  } = data;
  const { tags: innerTags } = data;
  const tags = { tags: innerTags };
  // const { quotaEnabled, inventoryQuota, stockQuantity, stockAvailable } = data;
  // const stock = {
  //   quotaEnabled,
  //   inventoryQuota: inventoryQuota || 0,
  //   stockQuantity,
  //   stockAvailable: stockAvailable || 0,
  // };、
  const { defaultSalePrice, taxRule, cost, defaultRrp, localPrices } = data;
  const { simpleProductPriceSettings = [] } = data;
  const advancedPriceSettings = buildGroupedPriceSettings(
    priceTiers,
    simpleProductPriceSettings,
  );

  const { dimensions } = data;
  const { customsInformation } = data;
  const { items = [] } = customsInformation || {};
  const customsInformationItems = items.map((i) => {
    return { ...i, key: randomNumber() };
  });
  const priceSettings = {
    defaultSalePrice,
    taxRule,
    cost,
    defaultRrp,
    localPrices,
  };
  return {
    productInfo,
    storeUuid,
    status,
    uuid,
    productStorage,
    productType,
    thumbnailImage,
    defaultCurrency,
    tags,
    //stock,
    priceSettings,
    advancedPriceSettings,
    dimensions,
    customsInformationItems,
    subCollapseOpen,
    // salesChannelAvailableQuantity: salesChannelAvailableQuantity,
    // salesChannelAvailablePresaleQuantity: salesChannelAvailablePresaleQuantity,
    ...reduxUpdatedStatusControl,
  };
};
